import { render, staticRenderFns } from "./DoiMatKhau.vue?vue&type=template&id=dcb82d9a"
import script from "./DoiMatKhau.vue?vue&type=script&lang=js"
export * from "./DoiMatKhau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports